import React from 'react'

import './RecentlyOrdered.css'
import Aux from '../../../../hoc/ReactAux/ReactAux'
import currencyUtils from 'utils/currency'
import NutritionFacts from '../Products/ProductDetails/NutritionFacts'

export const recentlyOrdered = (props) => {

  let classes = ''

  if (props.fastReOrderMenu && props.checkout) {
    classes = 'list-items recently-ordered cart-open fastreorder'
  } else if (props.fastReOrderMenu && !props.checkout) {
    classes = 'list-items recently-ordered recently-ordered'
    //classes = 'list-items-recently-ordered recently-ordered'
  } else if (!props.fastReOrderMenu && props.checkout) {
    classes = 'list-items recently-ordered cart-open'
  } else {
    classes = 'list-items recently-ordered'
  }

  return (
    <div className={classes}>
      <table>
        <tbody>
          <tr className="header">
            <th className="th-date">DATE</th>
            <th className="th-restaurant">RESTAURANT</th>
            <th className="th-order">ORDER</th>
            <th className="th-total">TOTAL</th>
          </tr>
        </tbody>
        <tbody>
          {props.recentlyOrdered.map((item, x) => (
            props.restaurantsOptions[0].active === true && item.restaurant.forCollection === 'N' ?
              <Aux key={x}>
                <tr className="item">
                  <td className="date">{(new Date(item.dateReg).toLocaleDateString('en-GB')).toString()}</td>
                  <td className="restaurant-name">{item.restaurant.name}</td>
                  <td className="items-order">
                    {item.orderItems.map((item, y) => (
                      <Aux key={y}>
                        <a>
                          <article>
                            <header>
                              <h3>{item.product.name}</h3>
                              <NutritionFacts product={item.product}></NutritionFacts>                              
                            </header>
                            <p>{item.product.description ? item.product.description : ''}</p>
                          </article>
                        </a>
                      </Aux>
                    ))}
                  </td>
                  <td className="price">
                    {currencyUtils.convertNameToSymbol(item.restaurant.currency) + item.totalAmount.toFixed(2)}
                  </td>
                  {item.canOrder && item.forCollection === 'N' &&
                    <td className="repeat">
                        <a onClick={() => props.addRepeatOrderProduct(item)}>Repeat</a>
                    </td>
                  }
                </tr>
              </Aux> :
              props.restaurantsOptions[1].active === true && item.restaurant.forCollection === 'Y' ?
                <Aux key={item.id}>
                  <tr className="item">
                    <td className="date">{(new Date(item.dateReg).toLocaleDateString('en-GB')).toString()}</td>
                    <td className="restaurant-name">{item.restaurant.name}</td>
                    <td className="items-order">
                      {item.orderItems.map(item => (
                        <Aux key={item.product.id}>
                          <a>
                            <article>
                              <header>
                                <h3>{item.product.name}</h3>
                                <NutritionFacts product={item.product}></NutritionFacts>
                              </header>
                              <p>{item.product.description ? item.product.description : ''}</p>
                            </article>
                          </a>
                        </Aux>
                      ))}
                    </td>
                    <td className="price">
                      {currencyUtils.convertNameToSymbol(item.restaurant.currency) + item.totalAmount.toFixed(2)}
                    </td>
                    {item.canOrder ?
                        <td className="repeat">
                          <a onClick={() => props.addRepeatOrderProduct(item)}>Repeat</a>
                        </td> : null
                    }
                  </tr>
                </Aux> : null
          ))
          }
        </tbody>
      </table>
      <p className="notice-reorder"><b>Plase Note:</b> Repeat order shows prices applied in the past. New prices may apply</p>
    </div>
  )
}

export default recentlyOrdered



// WEBPACK FOOTER //
// ./src/containers/Menu/MenuComponents/RecentlyOrdered/RecentlyOrdered.js